<template>
    <div class="management">
        <b-dropdown
            class="ellipsis-nav bordered-menu paper-show-paper-nav"
            variant="primary"
            right
            text="Right align"
            no-caret
            toggle-class="paper-show-paper-context-menu">
            <template #button-content>
                <i class="fas fa-fw fa-ellipsis-v"></i>
            </template>

            <b-dropdown-item
                class="open-presentation"
                :href="editPresentationUrl"
                target="_blank">
                <i class="fas fa-folder-open fa-fw"></i>{{ $t('common.open') }}
            </b-dropdown-item>

            <b-dropdown-item
                class="download-presentation"
                v-if="presentationEditorFileIn !== 0 && presentationEditorFileIn.editor_type !== 'mg'"
                :href="downloadPresentationUrl"
                target="_blank">
                <i class="btn-download"></i>{{ $t('common.download') }}
            </b-dropdown-item>

            <b-dropdown-item
                class="versions-paper"
                v-b-modal="'paper-power-point-versions-modal'"
                v-if="
                    (presentationEditorFileIn !== 0 && presentationEditorFileIn.editor_type === 'oo') ||
                    presentationEditorFileIn.editor_type === 'moo'
                ">
                <i class="btn-history"></i>{{ $t('paper.versions') }}
            </b-dropdown-item>

            <b-dropdown-item
                class="upload-presentation"
                v-b-modal="'paper-presentation-upload-modal'">
                <i class="btn-upload"></i>{{ $t('paper.upload') }}
            </b-dropdown-item>

            <b-dropdown-item
                class="plagiarism-presentation"
                v-b-modal="'paper-powerpoint-plagiarism-modal-' + presentationEditorFileIn.id"
                v-if="
                    !this.$authUser.isStudent() &&
                    presentationEditorFileIn !== 0 &&
                    presentationEditorFileIn.file_type === 'WORD'
                ">
                <i class="btn-play-circle"></i>{{ $t('paper.plagiarism_report') }}
            </b-dropdown-item>

            <b-dropdown-item
                class="plagiarism-paper-remove"
                v-if="this.$authUser.isAdmin() && presentationEditorFileIn !== 0"
                @click="removePaper">
                <i class="btn-remove"></i>{{ $t('paper.delete_paper') }}
            </b-dropdown-item>
        </b-dropdown>

        <design-2021-paper-presentation-upload-modal-component :id="projectIn.paper?.id">
        </design-2021-paper-presentation-upload-modal-component>

        <design-2021-paper-powerpoint-plagiarism-modal-component
            v-if="presentationEditorFileIn !== 0"
            :editor-file-id-in="presentationEditorFileIn?.id">
        </design-2021-paper-powerpoint-plagiarism-modal-component>

        <design-2021-paper-powerpoint-versions-modal-component
            :power-point-versions-in="powerPointVersionsIn"
            :id="projectIn.id"></design-2021-paper-powerpoint-versions-modal-component>
    </div>
</template>

<script>
import Design2021PaperPresentationUploadModalComponent from '../show/modals/design-2021-paper-presentation-upload-modal-component.vue';
import Design2021PaperPowerpointPlagiarismModalComponent from '../../roadmap/show/modals/design-2021-paper-powerpoint-plagiarism-modal-component.vue';
import Design2021PaperPowerpointVersionsModalComponent from '../show/modals/design-2021-paper-powerpoint-versions-modal-component.vue';

export default {
    name: 'design-2021-paper-show-powerpoint-buttons-component',
    components: {
        Design2021PaperPowerpointVersionsModalComponent,
        Design2021PaperPowerpointPlagiarismModalComponent,
        Design2021PaperPresentationUploadModalComponent,
    },

    // TODO: Make nullable instead of 'zeroable'.
    props: {
        downloadPresentationUrl: String,
        editPresentationUrl: String,
        presentationEditorFileIn: {
            type: [Object, Number],
        },
        projectIn: Object,
        editorFileIn: {
            type: [Object, Number],
        },
        powerPointVersionsIn: Array,
    },

    methods: {
        removePaper() {
            if (this.presentationEditorFileIn === 0) {
                return;
            }

            this.alert
                .confirm(this.$t('paper.delete_paper'), this.$t('paper.are_you_sure_you_want_to_delete_this_paper'))
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving(this.$t('paper.delete_paper'), this.$t('paper.paper_will_be_removed'));
                        this.axios.delete(this.routes.paperEditorDelete(this.presentationEditorFileIn.id)).then(
                            (response) => {
                                this.alert.success();

                                window.location.reload();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
.open-presentation,
.download-presentation,
.upload-presentation,
.plagiarism-presentation,
.versions-paper {
    i {
        color: var(--primary);
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}

.management {
    align-self: center;
    margin-left: auto;
}
</style>
